import { render } from "./CorporateSocial.vue?vue&type=template&id=106b6d74&scoped=true"
import script from "./CorporateSocial.vue?vue&type=script&lang=js"
export * from "./CorporateSocial.vue?vue&type=script&lang=js"

import "./CorporateSocial.vue?vue&type=style&index=0&id=106b6d74&scoped=true&lang=css"

import exportComponent from "/home/aria/Documents/gawean/pt.ksi/program/vue/ksi_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106b6d74"]])

export default __exports__